import {
    absurdPrefixes, absurdSuffixes,
    trAbsurdPrefixes, trAbsurdSuffixes,
    frAbsurdPrefixes, frAbsurdSuffixes,
    esAbsurdPrefixes, esAbsurdSuffixes,
    deAbsurdPrefixes, deAbsurdSuffixes,
    ptAbsurdPrefixes, ptAbsurdSuffixes,
    arAbsurdPrefixes, arAbsurdSuffixes,
    hiAbsurdPrefixes, hiAbsurdSuffixes,
    jaAbsurdPrefixes, jaAbsurdSuffixes,
    koAbsurdPrefixes, koAbsurdSuffixes,
    idAbsurdPrefixes, idAbsurdSuffixes,
    viAbsurdPrefixes, viAbsurdSuffixes,
    ruAbsurdPrefixes, ruAbsurdSuffixes,
    itAbsurdPrefixes, itAbsurdSuffixes,
    plAbsurdPrefixes, plAbsurdSuffixes,
    nlAbsurdPrefixes, nlAbsurdSuffixes,

    sillyPrefixes, sillySuffixes,
    trSillyPrefixes, trSillySuffixes,
    frSillyPrefixes, frSillySuffixes,
    esSillyPrefixes, esSillySuffixes,
    deSillyPrefixes, deSillySuffixes,
    ptSillyPrefixes, ptSillySuffixes,
    arSillyPrefixes, arSillySuffixes,
    hiSillyPrefixes, hiSillySuffixes,
    jaSillyPrefixes, jaSillySuffixes,
    koSillyPrefixes, koSillySuffixes,
    idSillyPrefixes, idSillySuffixes,
    viSillyPrefixes, viSillySuffixes,
    ruSillyPrefixes, ruSillySuffixes,
    itSillyPrefixes, itSillySuffixes,
    plSillyPrefixes, plSillySuffixes,
    nlSillyPrefixes, nlSillySuffixes,

    goofyNames,
    trGoofyNames,
    frGoofyNames,
    esGoofyNames,
    deGoofyNames,
    ptGoofyNames,
    arGoofyNames,
    hiGoofyNames,
    jaGoofyNames,
    koGoofyNames,
    idGoofyNames,
    viGoofyNames,
    ruGoofyNames,
    itGoofyNames,
    plGoofyNames,
    nlGoofyNames
} from '@/constants/funnyNames';

interface LocaleData {
    absurdPrefixes: string[];
    absurdSuffixes: string[];
    sillyPrefixes: string[];
    sillySuffixes: string[];
    goofyNames: string[];
}

const localeDataMap: Record<string, LocaleData> = {
    en: { absurdPrefixes, absurdSuffixes, sillyPrefixes, sillySuffixes, goofyNames },
    tr: { absurdPrefixes: trAbsurdPrefixes, absurdSuffixes: trAbsurdSuffixes, sillyPrefixes: trSillyPrefixes, sillySuffixes: trSillySuffixes, goofyNames: trGoofyNames },
    fr: { absurdPrefixes: frAbsurdPrefixes, absurdSuffixes: frAbsurdSuffixes, sillyPrefixes: frSillyPrefixes, sillySuffixes: frSillySuffixes, goofyNames: frGoofyNames },
    es: { absurdPrefixes: esAbsurdPrefixes, absurdSuffixes: esAbsurdSuffixes, sillyPrefixes: esSillyPrefixes, sillySuffixes: esSillySuffixes, goofyNames: esGoofyNames },
    de: { absurdPrefixes: deAbsurdPrefixes, absurdSuffixes: deAbsurdSuffixes, sillyPrefixes: deSillyPrefixes, sillySuffixes: deSillySuffixes, goofyNames: deGoofyNames },
    pt: { absurdPrefixes: ptAbsurdPrefixes, absurdSuffixes: ptAbsurdSuffixes, sillyPrefixes: ptSillyPrefixes, sillySuffixes: ptSillySuffixes, goofyNames: ptGoofyNames },
    ar: { absurdPrefixes: arAbsurdPrefixes, absurdSuffixes: arAbsurdSuffixes, sillyPrefixes: arSillyPrefixes, sillySuffixes: arSillySuffixes, goofyNames: arGoofyNames },
    hi: { absurdPrefixes: hiAbsurdPrefixes, absurdSuffixes: hiAbsurdSuffixes, sillyPrefixes: hiSillyPrefixes, sillySuffixes: hiSillySuffixes, goofyNames: hiGoofyNames },
    ja: { absurdPrefixes: jaAbsurdPrefixes, absurdSuffixes: jaAbsurdSuffixes, sillyPrefixes: jaSillyPrefixes, sillySuffixes: jaSillySuffixes, goofyNames: jaGoofyNames },
    ko: { absurdPrefixes: koAbsurdPrefixes, absurdSuffixes: koAbsurdSuffixes, sillyPrefixes: koSillyPrefixes, sillySuffixes: koSillySuffixes, goofyNames: koGoofyNames },
    id: { absurdPrefixes: idAbsurdPrefixes, absurdSuffixes: idAbsurdSuffixes, sillyPrefixes: idSillyPrefixes, sillySuffixes: idSillySuffixes, goofyNames: idGoofyNames },
    vi: { absurdPrefixes: viAbsurdPrefixes, absurdSuffixes: viAbsurdSuffixes, sillyPrefixes: viSillyPrefixes, sillySuffixes: viSillySuffixes, goofyNames: viGoofyNames },
    ru: { absurdPrefixes: ruAbsurdPrefixes, absurdSuffixes: ruAbsurdSuffixes, sillyPrefixes: ruSillyPrefixes, sillySuffixes: ruSillySuffixes, goofyNames: ruGoofyNames },
    it: { absurdPrefixes: itAbsurdPrefixes, absurdSuffixes: itAbsurdSuffixes, sillyPrefixes: itSillyPrefixes, sillySuffixes: itSillySuffixes, goofyNames: itGoofyNames },
    pl: { absurdPrefixes: plAbsurdPrefixes, absurdSuffixes: plAbsurdSuffixes, sillyPrefixes: plSillyPrefixes, sillySuffixes: plSillySuffixes, goofyNames: plGoofyNames },
    nl: { absurdPrefixes: nlAbsurdPrefixes, absurdSuffixes: nlAbsurdSuffixes, sillyPrefixes: nlSillyPrefixes, sillySuffixes: nlSillySuffixes, goofyNames: nlGoofyNames },
};

export interface FunnyNameGeneratorOptions {
    count?: number;
    style?: 'absurd' | 'silly' | 'any';
    locale?: string;
}

export function generateFunnyNames(options: FunnyNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const style = options.style || 'any';
    const locale = options.locale || 'en';
    const names: string[] = [];

    const data = localeDataMap[locale] || localeDataMap['en'];
    const enData = localeDataMap['en'];

    for (let i = 0; i < count; i++) {
        let currentStyle = style;
        if (currentStyle === 'any') {
            const styles = ['absurd', 'silly'];
            currentStyle = styles[Math.floor(Math.random() * styles.length)] as 'absurd' | 'silly';

            // Occasionally pick a pre-defined goofy name if 'any' is selected
            if (Math.random() < 0.1) {
                const list = data.goofyNames.length > 0 ? data.goofyNames : enData.goofyNames;
                names.push(list[Math.floor(Math.random() * list.length)]);
                continue;
            }
        }

        let prefix = '';
        let suffix = '';

        switch (currentStyle) {
            case 'absurd':
                prefix = data.absurdPrefixes[Math.floor(Math.random() * data.absurdPrefixes.length)];
                suffix = data.absurdSuffixes[Math.floor(Math.random() * data.absurdSuffixes.length)];
                names.push(`${prefix}${suffix}`);
                break;
            case 'silly':
                prefix = data.sillyPrefixes[Math.floor(Math.random() * data.sillyPrefixes.length)];
                suffix = data.sillySuffixes[Math.floor(Math.random() * data.sillySuffixes.length)];
                // Silly names often have a space or hyphen
                names.push(`${prefix} ${suffix}`);
                break;
        }
    }

    return names;
}
